import { useRef } from 'react'
import axios, { AxiosInstance } from 'axios'
import { useAuth0 } from '@auth0/auth0-react'

export function useAxiosAuth0(): AxiosInstance {
    const { getAccessTokenSilently } = useAuth0()
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000'
    const API_V1_URL = `${API_BASE_URL}/v1`
    const axiosInstanceRef = useRef<AxiosInstance | null>(null)

    if (!axiosInstanceRef.current) {
        const instance = axios.create({
            baseURL: API_V1_URL,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        })

        instance.interceptors.request.use(
            async (config) => {
                try {
                    const token = await getAccessTokenSilently()
                    if (token && config.headers) {
                        config.headers.Authorization = `Bearer ${token}`
                    }
                    return config
                } catch (error) {
                    console.error('Error al obtener token de Auth0:', error)
                    return config
                }
            },
            (error) => Promise.reject(error)
        )

        instance.interceptors.response.use(
            (response) => response,
            (error) => {
                if (error?.response?.status === 401) {
                    console.warn('Token inválido o expirado, redirigiendo al login...')
                    window.location.replace('/login')
                }
                return Promise.reject(error)
            }
        )

        axiosInstanceRef.current = instance
    }

    return axiosInstanceRef.current
}
